import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../scss/custom.scss';
import {
  Button,
  TableToolbar,
  Loading,
} from 'carbon-components-react';
import { drill, api, me } from '../../helpers/api/api';
import { showNotification } from '../../helpers/notification/BaseNotification';
import { AppContext } from '../../helpers/context/AppContext';
import { IsEnabled, IsInRole } from '../../helpers/authorization/Policies';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { getError, getSuccess, entitiesLabels, apioperation, PlannedWeekChangeType } from '../../helpers/Constants';


// RITM0860478
export default class AnnualDrillPlanDownload extends Component {
  constructor(props) {
    super(props);
    this.year = props ? props.match.params.year : '';
    this.id = props ? props.match.params.id : '';
    this.hver = props ? props.match.params.hver : '';
    this.hash = props ? props.match.params.hash : '';

    
    this.state = {
      isDownloadingAnnualDrillPlanFile: false, // RITM0860478
    };
      
    console.log(`AnnualDrillPlanDownload.constructor:`);
    
  }


  async componentDidMount() {
    console.log(`AnnualDrillPlanDownload.componentDidMount:`);
    this.DownloadAnnualDrillPlan(this.year, this.id, this.hver, this.hash);
  }
  
  // RITM0860478
  DownloadAnnualDrillPlan(year, idWorksite, hver, hash) {
    console.log(`AnnualDrillPlanDownload.DownloadAnnualDrillPlan: year: ${year} idWorksite: ${idWorksite} hver: ${hver} hash: ${hash}`);
    var reqUrl = '';
    var fileName = 'Annual_Drill_Plan' + year + '.zip';
    if (year != '' && idWorksite != '' && hver != '' && hash != '') {
      reqUrl = '/drill/exportannualdrillplanbylink/ws/' + year + '/' + idWorksite + '/' + hver + '/' + hash;
    } else {
      showNotification.error(`${entitiesLabels.ERROR}`,
        getError('No worksite or project selected!', entitiesLabels.EMERGENCYDRILL_ANNUALPLAN, apioperation.DOWNLOAD));
      return;
    }
    console.log(`AnnualDrillPlanDownload.DownloadAnnualDrillPlan: fileName: ${fileName}`);

    this.setState({
      isDownloadingAnnualDrillPlanFile: true,
    });
    api
      .getWithParam(reqUrl , {
        responseType: 'arraybuffer',
      })
      .then((response) => {
        var data = new Blob([response.data], { type: 'application/zip' });
        var csvURL = window.URL.createObjectURL(data);
        var tempLink = document.createElement('a');
        tempLink.href = csvURL;
        tempLink.setAttribute('download', fileName);
        document.body.appendChild(tempLink);
        tempLink.click();
      })
      .catch((error) => {
        showNotification.error(`${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.EMERGENCYDRILL_ANNUALPLAN, apioperation.DOWNLOAD)
        );
      })
      .finally(() => {
        this.setState({
          isDownloadingAnnualDrillPlanFile: false,
         });
      });
  }
    
  
  renderLoadingModal = () => {
    const show = this.state.isDownloadingAnnualDrillPlanFile; // RITM0860478
    console.log(`AnnualDrillPlanDownload.renderLoadingModal: show: ${show}`);
    return show && <Loading active withOverlay description={'Dowloading Annual Drill Plan'} />;
  };
  
  render() {
    console.log(`AnnualDrillPlanDownload.render:`);
    return (
        <div>
          {this.renderLoadingModal()}
        </div>
    );
  }
}

AnnualDrillPlanDownload.propTypes = {
  history: PropTypes.shape({
    block: PropTypes.func,
    createHref: PropTypes.func,
    go: PropTypes.func,
    goBack: PropTypes.func,
    goForward: PropTypes.func,
    listen: PropTypes.func,
    push: PropTypes.func,
    replace: PropTypes.func,
    length: PropTypes.number,
    action: PropTypes.string,
    location: PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      key: PropTypes.string
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string,
    hash: PropTypes.string,
    key: PropTypes.string
  }).isRequired
};
